// extracted by mini-css-extract-plugin
export default {"chats":"chats_chats__2ksTp","chat_list":"chats_chat_list__8AePW","messaging":"chats_messaging__1sZIk"};